
const defaultState = {
    // Every client, for the contact pickers. The contacts table shows `tableRows`, one server page.
    rows: undefined,
    rowsStale: false,
    tableRows: undefined,
    total: 0,
    paging: { page: 0, pageSize: 30, sort: undefined, desc: false, append: false },
    loadingPage: false,
    contacts: undefined,
    current: {},
    currentCases: undefined,
    refreshNeeded: true,
    loadingCurrent: false,
    savingNeeded: false,
    filter: undefined,
    tabState: undefined,
};

export const clientsReducer = (state = defaultState, action) => {
    let contacts;
    let rows;
    let contact;
    switch (action.type) {
        case 'CLIENTS_LOAD_SUCCESS':
            if (action.paged) {
                return {
                    ...state,
                    // Scrolling to the end appends the next page; anything else replaces the rows.
                    tableRows: action.append && state.tableRows
                        ? [...state.tableRows, ...action.result.data.clients.filter(c => !state.tableRows.some(r => r.client.id === c.client.id))]
                        : [...action.result.data.clients],
                    total: action.result.data.total,
                    // The server clamps the page when the result set shrank.
                    paging: { ...state.paging, page: action.result.data.page, append: false },
                    refreshNeeded: false,
                    loadingPage: false,
                    loadingCurrent: false,
                };
            }

            contacts = [];
            if (action.result.data.contacts) {
                contacts = action.result.data.contacts.map(contact => contact.client);
            }

            rows = [];
            if (action.result.data.clients) {
                rows = action.result.data.clients;
            }

            return {
                ...state,
                rows: [...rows],
                rowsStale: false,
                contacts: [...contacts],
                loadingCurrent: false,
            };

        case 'CONTACTS_LOAD_SUCCESS':
            contacts = [];
            if (action.result.data.contacts) {
                contacts = action.result.data.contacts.map(contact => contact.client);
            }

            return {
                ...state,
                contacts: [...contacts],
            };

        case 'CONTACT_FORM_SAVE_SUCCESS':
            contacts = [];
            if (state.contacts) {
                contacts = [...state.contacts];
            }

            contact = { ...action.result.data.client };
            if (contact['ClientType'] && contact['ClientType'] !== 'Client') {
                const index = contacts.findIndex(v => v.id === contact.id);
                if (index === -1) {
                    contacts.unshift(contact);
                } else {
                    contacts[index] = contact;
                }
            }

            return {
                ...state,
                contacts,
            };

        case 'CLIENTS_LOAD_REQUEST':
            if (!action.paged) {
                return state;
            }

            return {
                ...state,
                refreshNeeded: false,
                loadingPage: true,
            };

        case 'CLIENTS_LOAD_FAILURE':
            if (!action.paged) {
                return { ...state, loadingCurrent: false };
            }

            return {
                ...state,
                loadingCurrent: false,
                loadingPage: false,
                refreshNeeded: true,
            };

        case 'CLIENTS_PAGING':
            // Keep the current rows on screen while the new page loads.
            return {
                ...state,
                paging: { ...state.paging, append: false, ...action.paging },
                refreshNeeded: true,
            };

        case 'CLIENTS_FILTER':
            return {
                ...state,
                filter: action.filter
            };

        case 'CLIENTS_COLUMNS_SET_REQUEST':
            return {
                ...state,
                headers: [...action.headers]
            };

        case 'CLIENT_NEW':
            return {
                ...state,
                current: {},
                currentCases: undefined,
                loadingCurrent: false,
                savingNeeded: false,
                tabState: 'new',
            };

        case 'CLIENT_EDIT':
            return {
                ...state,
                current: {...action.current},
                currentCases: undefined,
                loadingCurrent: false,
                tabState: 'edit',
            };

        case 'CLIENT_CASES_EDIT':
            return {
                ...state,
                currentCases: [...action.cases],
            };

        case 'CONTACTS_IMPORT_SUCCESS':
        case 'CLIENTS_DELETE_IDS_SUCCESS':
        case 'CLIENT_DELETE_ID_SUCCESS':
            return {
                ...state,
                refreshNeeded: true,
                rowsStale: true,
            };

        case 'CLIENT_EDIT_ID_REQUEST':
            return {
                ...state,
                current: {...action.initialClient},
                currentCases: undefined,
                loadingCurrent: true,
            };

        case 'CLIENT_EDIT_ID_SUCCESS':
            return {
                ...state,
                current: {...action.result.data.client},
                loadingCurrent: false,
                currentCases: [...action.result.data.cases],
                tabState: 'edit',
            };

        case 'CLIENT_EDIT_ID_FAILURE':
            return {
                ...state,
                current: {},
                currentCases: undefined,
                loadingCurrent: false,
            };

        case 'CLIENTS_ALL':
            return {
                ...state,
                tabState: 'all'
            };

        case 'CLIENT_SAVING_NEEDED':
            return {
                ...state,
                savingNeeded: action.savingNeeded
            };

        case 'CLIENTS_REFRESH_NEEDED':
            return {
                ...state,
                refreshNeeded: action.refreshNeeded,
                rowsStale: state.rowsStale || (action.refreshNeeded && !!action.dataChanged),
                // Blank the table while it reloads, as before. `rows` (pickers) stays put.
                tableRows: action.refreshNeeded ? undefined : state.tableRows,
            };

        case 'CLIENT_TYPE_SET':
            return {
                ...state,
                current: {...state.current, ClientType: action.clientType}
            };

        case 'IMPERSONATE_EMPLOYEE_SUCCESS':
            return {
                ...defaultState
            };

        case 'PUBLIC_CASE_GET_SUCCESS':
            contacts = [];
            if (action.result.data.contacts) {
                contacts = action.result.data.contacts.map(contact => contact.client);
            }

            return {
                ...state,
                contacts: [ ...contacts]
            };

        default:
            return state;
    }
};